// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3eNOM","name":"ConsentHeader_name__2bJLc","birthday":"ConsentHeader_birthday__2Mc62","skeleton":"ConsentHeader_skeleton__16w9z"};